import isString from 'transmute/isString';
import { STATIC, isRollingDatePointType } from '../../types/operator/RollingDatePointType';
import { DateStaticOrDynamicDisplayType } from '../DisplayTypes';
import { DateStaticOrDynamicInputType } from '../InputTypes';
import { makeOperator } from './Operator';
import { validateRollingDatePointConfig } from '../rollingDates/RollingDatePointConfig';

// value should correspond to Greater<String>'s value when type is STATIC, AfterRollingDatePoint's value when type is DYNAMIC
export default makeOperator({
  displayType: DateStaticOrDynamicDisplayType,
  inputType: DateStaticOrDynamicInputType,
  name: 'AfterDateStaticOrDynamic',
  values: [{
    name: 'value',
    isValid: value => !!value && (isString(value) || validateRollingDatePointConfig(value))
  }, {
    name: 'type',
    defaultValue: STATIC,
    isValid: isRollingDatePointType
  }]
});